import cookiebotClient from './cookiebotClient'

export default cookiebotClient
